"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9567],{

/***/ 29567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ GoogleMapContent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./helpers/i18n.ts + 7 modules
var i18n = __webpack_require__(72462);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/@react-google-maps/api/dist/esm.js
var esm = __webpack_require__(37054);
// EXTERNAL MODULE: ./node_modules/@googlemaps/markerclusterer/dist/index.esm.js + 5 modules
var index_esm = __webpack_require__(84576);
// EXTERNAL MODULE: ./api/client.ts
var client = __webpack_require__(57093);
// EXTERNAL MODULE: ./helpers/class/Checkers.ts
var Checkers = __webpack_require__(55791);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(73582);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 1 modules
var _create_super = __webpack_require__(71418);
;// CONCATENATED MODULE: ./components/GoogleMaps/OverlayNext.ts



function createOverlay(container, pane, position, offsetX, offsetY) {
    var OverlayNext = /*#__PURE__*/ function(_OverlayView) {
        "use strict";
        (0,_inherits/* default */.Z)(OverlayNext, _OverlayView);
        var _super = (0,_create_super/* default */.Z)(OverlayNext);
        function OverlayNext(container, pane, position, offsetX, offsetY) {
            (0,_class_call_check/* default */.Z)(this, OverlayNext);
            var _this;
            _this = _super.call(this);
            _this.container = container;
            _this.pane = pane;
            _this.position = position;
            _this.offsetX = offsetX;
            _this.offsetY = offsetY;
            return _this;
        }
        var _proto = OverlayNext.prototype;
        _proto.onAdd = function onAdd() {
            var ref;
            var _$pane = (ref = this.getPanes()) === null || ref === void 0 ? void 0 : ref[this.pane];
            _$pane === null || _$pane === void 0 ? void 0 : _$pane.appendChild(this.container);
        };
        _proto.draw = function draw() {
            var projection = this.getProjection();
            var point = projection.fromLatLngToDivPixel(this.position);
            if (point === null) {
                return;
            }
            this.container.style.transform = "translate(".concat(point.x - this.offsetX, "px, ").concat(point.y - this.offsetY, "px)");
        };
        _proto.onRemove = function onRemove() {
            if (this.container.parentNode !== null) {
                this.container.parentNode.removeChild(this.container);
            }
        };
        return OverlayNext;
    }(google.maps.OverlayView);
    return new OverlayNext(container, pane, position, offsetX, offsetY);
}

;// CONCATENATED MODULE: ./components/GoogleMaps/OverlayView.tsx



function OverlayView(param) {
    var position = param.position, _pane = param.pane, pane = _pane === void 0 ? "floatPane" : _pane, map = param.map, zIndex = param.zIndex, offsetX = param.offsetX, offsetY = param.offsetY, className = param.className, children = param.children;
    var container = (0,react.useMemo)(function() {
        var div = document.createElement("div");
        div.style.position = "absolute";
        return div;
    }, []);
    var overlay = (0,react.useMemo)(function() {
        return createOverlay(container, pane, position, offsetX, offsetY);
    }, [
        container,
        pane,
        position,
        offsetX,
        offsetY
    ]);
    (0,react.useEffect)(function() {
        overlay === null || overlay === void 0 ? void 0 : overlay.setMap(map);
        return function() {
            return overlay === null || overlay === void 0 ? void 0 : overlay.setMap(null);
        };
    }, [
        map,
        overlay
    ]);
    // to move the container to the foreground and background
    (0,react.useEffect)(function() {
        container.style.zIndex = "".concat(zIndex);
        if (className) if (className.split(" ").length > 1) {
            className.split(" ").map(function(thisClass) {
                return container.classList.add(thisClass);
            });
        } else {
            if (className.length > 0) container.classList.add(className);
        }
    }, [
        zIndex,
        container,
        className
    ]);
    return /*#__PURE__*/ (0,react_dom.createPortal)(children, container);
}

// EXTERNAL MODULE: ./helpers/MethodHelper.ts
var MethodHelper = __webpack_require__(28695);
;// CONCATENATED MODULE: ./components/GoogleMaps/CustomMarker.tsx









function CustomMarker(_param) {
    var marker_id = _param.marker_id, propertyMarkerClass = _param.propertyMarkerClass, position = _param.position, map = _param.map, offsetX = _param.offsetX, offsetY = _param.offsetY, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "marker_id",
        "propertyMarkerClass",
        "position",
        "map",
        "offsetX",
        "offsetY",
        "children"
    ]);
    var rgbDesignColor = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "designColor");
    });
    // useEffect( () => {
    //     console.log("rgbDesignColor", rgbDesignColor)
    // })
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: map && /*#__PURE__*/ (0,jsx_runtime.jsxs)(OverlayView, {
            map: map,
            position: position,
            className: "d-flex flex-column-reverse justify-content-start align-items-center",
            offsetX: offsetX,
            offsetY: offsetY,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    id: marker_id,
                    className: propertyMarkerClass,
                    onClick: props.onClick,
                    disabled: props.disabled,
                    style: {
                        border: "2px solid " + (Checkers/* default.isHexColor */.Z.isHexColor(rgbDesignColor) ? rgbDesignColor : "#333333")
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        className: "fs-16",
                        icon: pro_solid_svg_icons/* faHome */.J9Y,
                        style: {
                            height: 16,
                            width: 16
                        }
                    })
                }),
                children
            ]
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
}

// EXTERNAL MODULE: ./components/templates/properties/panel/Gallery.tsx
var Gallery = __webpack_require__(96491);
// EXTERNAL MODULE: ./components/templates/properties/panel/PanelBody.tsx + 2 modules
var PanelBody = __webpack_require__(79075);
// EXTERNAL MODULE: ./redux/actions.js
var actions = __webpack_require__(23077);
// EXTERNAL MODULE: ./node_modules/react-error-boundary/dist/react-error-boundary.esm.js
var react_error_boundary_esm = __webpack_require__(4511);
;// CONCATENATED MODULE: ./components/GoogleMaps/MarkerWrapper.tsx







function MarkerWrapper(param) {
    var key = param.key, position = param.position, clusterer = param.clusterer, property = param.property, infoWindowState = param.infoWindowState, updateInfoWindowState = param.updateInfoWindowState, changeMarkerOnClick = param.changeMarkerOnClick, markerClass = param.markerClass, pixelOffsetX = param.pixelOffsetX, pixelOffsetY = param.pixelOffsetY, openInfoWindow = param.openInfoWindow, map = param.map, setInfoWindowState = param.setInfoWindowState, secondState = param.secondState, randomizePin = param.randomizePin, isEstate = param.isEstate;
    var t = (0,i18n/* useT */.NT)();
    var localizePath = (0,i18n/* useLocalizePath */.Wb)();
    var isEstateView = isEstate != undefined ? isEstate : false;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_error_boundary_esm/* ErrorBoundary */.SV, {
            fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: t("common.somethingWentWrong")
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Marker */.Jx, {
                position: position,
                clusterer: clusterer,
                onClick: function() {
                    updateInfoWindowState(property.property_id);
                    changeMarkerOnClick(position.lat, position.lng, property.property_id);
                },
                icon: {
                    url: "https://loggia-cdn.s3.eu-central-1.amazonaws.com/solid_home_white-1.png",
                    anchor: new window.google.maps.Point(19, 19),
                    strokeWeight: 10,
                    strokeColor: "#000000"
                },
                children: infoWindowState === property.property_id && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InfoWindow */.nx, {
                    zIndex: 2,
                    position: position,
                    options: {
                        pixelOffset: new window.google.maps.Size(-pixelOffsetX, -pixelOffsetY)
                    },
                    onDomReady: function onDomReady() {
                        var noGalleryWidthDifference = 324 - this.content.children[0].clientWidth;
                        var noGalleryHeightDifference = 310 - this.content.children[0].clientHeight;
                        var width = (this.content.children[0].clientWidth + noGalleryWidthDifference) / 2;
                        var height = this.content.children[0].clientHeight + noGalleryHeightDifference + 20 + 76;
                        if (width > 0 && height > 20) {
                            openInfoWindow(width, height);
                        }
                        var gmEmptyElements = document.querySelectorAll(".gm-style-iw-tc");
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            for(var _iterator = gmEmptyElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var gmEmptyEl = _step.value;
                                gmEmptyEl.remove();
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "info_window_" + property.property_id,
                        className: "".concat(!secondState ? "bg-transparent border-radius-12 position-absolute mb-5 z-index-5" : "bg-white border-radius-12 position-absolute mb-5 z-index-5"),
                        style: {
                            overflow: "hidden",
                            boxShadow: !secondState ? "unset" : "0 6px 20px rgba(0,0,0,.2)"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            href: window.location.origin + localizePath(property.sourcePath),
                            target: "_blank",
                            rel: "noreferrer",
                            className: !secondState ? "invisible" : "InfoWindow-Properties__Thumb",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Gallery/* default */.Z, {
                                    height: 210,
                                    borderBottom: false,
                                    property_id: property.property_id,
                                    images: property.featured_images,
                                    setInfoWindowState: setInfoWindowState,
                                    captions: property.captions
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PanelBody/* default */.Z, {
                                    property_id: property.property_id,
                                    property_title: property.property_title,
                                    property_moto: property.moto,
                                    property_location: property.location,
                                    minimumPrice: property.minimumPrice,
                                    bedrooms: property.bedrooms,
                                    complexCount: property.complexCount,
                                    capacity: property.capacity,
                                    isEstate: isEstateView
                                })
                            ]
                        })
                    })
                })
            }, key)
        })
    });
}

;// CONCATENATED MODULE: ./components/GoogleMapContent.tsx















function GoogleMapContent(props) {
    var localizePath = (0,i18n/* useLocalizePath */.Wb)();
    var t = (0,i18n/* useT */.NT)();
    var isEstate = props.isEstate != undefined ? props.isEstate : false;
    var hidePin = props.hasOwnProperty("hidePin") ? props.hidePin : false;
    var dispatch = (0,es/* useDispatch */.I0)();
    var propertiesOffset = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["offset"];
    });
    var pageNumber = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"]["pageNumber"];
    });
    var disableUiControls = Checkers/* default.valueToBoolean */.Z.valueToBoolean(props.app.builder.builder_propertylist_map_disable_controls);
    var builderPropertiesAllProperties = (0,es/* useSelector */.v9)(function(state) {
        return (0,MethodHelper/* fetchBuilderSettingByKey */.iS)(state["builderSettingsData"], "builder_propertylist_map_all_properties");
    });
    var propertiesParams = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"];
    });
    var searchWithMap = propertiesParams["searchWithMap"] != undefined ? propertiesParams["searchWithMap"] : false;
    var ref = (0,react.useState)([]), propertiesMapPois = ref[0], setPropertiesMapPois = ref[1];
    var allPropertiesFetched = false;
    var fetchAllProperties = (0,react.useCallback)(function() {
        var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : propertiesParams, page_number = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : pageNumber, offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : propertiesOffset;
        if (builderPropertiesAllProperties == 1 && allPropertiesFetched) {
            return;
        }
        if (builderPropertiesAllProperties == 0) {
            setPropertiesMapPois(props.propertiesPois);
            return;
        }
        if (!allPropertiesFetched) {
            allPropertiesFetched = true;
            (0,client/* getAllPropertiesForMap */.pv)(params, builderPropertiesAllProperties).then(function(response) {
                setPropertiesMapPois(response);
            });
        }
    }, [
        propertiesParams
    ]);
    (0,react.useEffect)(function() {
        fetchAllProperties();
    }, [
        props.propertiesPois
    ]);
    var googleMapApiKey = props.googleMapApiKey;
    var forProperties = props.hasOwnProperty("propertiesPois") && Checkers/* default.isValidArray */.Z.isValidArray(propertiesMapPois);
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), map = ref1[0], setMap = ref1[1];
    var ref2 = (0,react.useState)(false), isMounted = ref2[0], setIsMounted = ref2[1];
    (0,react.useEffect)(function() {
        if (document.getElementById("gm-style-iw-reset")) {
            return;
        }
        var style = document.createElement("style");
        style.id = "gm-style-iw-reset";
        style.innerHTML = ".gm-style-iw-c{padding:0 !important;}" + ".gm-style-iw-d{overflow:hidden !important;padding:0 !important;}" + ".gm-style-iw-t::after{display:none !important;}" + ".gm-ui-hover-effect{display:none !important;}" + ".gm-style-iw-ch{display:none !important;padding:0 !important;}";
        document.head.appendChild(style);
    }, []);
    (0,react.useEffect)(function() {
        if (!map || !Checkers/* default.isValidArray */.Z.isValidArray(props.map_pois)) {
            return;
        }
        var infoWindow = new google.maps.InfoWindow();
        var markers = [];
        props.map_pois.forEach(function(poi) {
            var lat = parseFloat(poi.property_poi_latitude);
            var lng = parseFloat(poi.property_poi_longitude);
            if (!Checkers/* default.isValidLatitude */.Z.isValidLatitude(lat) || !Checkers/* default.isValidLongitude */.Z.isValidLongitude(lng)) {
                return;
            }
            var marker = new google.maps.Marker({
                position: {
                    lat: lat,
                    lng: lng
                },
                title: poi.property_poi_title
            });
            marker.addListener("click", function() {
                var directionsHref = Checkers/* default.isValidString */.Z.isValidString(poi.property_poi_custom_direction) ? poi.property_poi_custom_direction : "https://www.google.com/maps/dir/" + poi.property_poi_latitude + "," + poi.property_poi_longitude + "/" + props.center.lat + "," + props.center.lng;
                var content = document.createElement("div");
                content.style.width = "260px";
                content.style.fontFamily = "inherit";
                content.style.position = "relative";
                content.style.padding = "16px";
                content.style.boxSizing = "border-box";
                content.innerHTML = '<button class="poi-info-close" aria-label="Close" style="position:absolute;top:8px;right:8px;width:20px;height:20px;border:none;background:transparent;cursor:pointer;font-size:18px;line-height:1;color:#5f6368;padding:0;">&times;</button>' + '<div style="font-size:17px;font-weight:600;color:#202124;margin-bottom:10px;padding-right:20px;">' + poi.property_poi_title + "</div>" + (Checkers/* default.isValidString */.Z.isValidString(poi.property_poi_description) ? '<div style="font-size:13px;color:#70757a;line-height:1.6;margin-bottom:12px;">' + poi.property_poi_description + "</div>" : "") + '<a rel="noreferrer" target="_blank" href="' + directionsHref + '" style="font-size:13px;color:#1a73e8;text-decoration:none;display:inline-flex;align-items:center;gap:6px;">' + '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1a73e8" stroke-width="1.8"><path d="M4 5c2.5-1.3 5-1.3 7 0v14c-2-1.3-4.5-1.3-7 0V5z"/><path d="M11 5c2.5-1.3 5-1.3 7 0v14c-2-1.3-4.5-1.3-7 0"/><path d="M11 5v14"/></svg>' + "Directions</a>";
                content.querySelector(".poi-info-close").addEventListener("click", function() {
                    return infoWindow.close();
                });
                infoWindow.setContent(content);
                infoWindow.open(map, marker);
            });
            markers.push(marker);
        });
        var clusterer = new index_esm/* MarkerClusterer */.XL({
            map: map,
            markers: markers
        });
        return function() {
            // Defensive: if Google Maps failed to initialize properly (e.g. a
            // RefererNotAllowedMapError from an API key restriction), its internal
            // objects can be left in a broken state where these cleanup calls throw -
            // better to swallow that here than crash the whole page on unmount.
            try {
                clusterer.clearMarkers();
                markers.forEach(function(marker) {
                    return marker.setMap(null);
                });
                infoWindow.close();
            } catch (e) {}
        };
    }, [
        map,
        props.map_pois
    ]);
    var onLoad = react.useCallback(function callback(map) {
        var bounds = new google.maps.LatLngBounds();
        if (Checkers/* default.objChildExists */.Z.objChildExists(props, "propertiesPois")) {
            propertiesMapPois.map(function(marker) {
                if (Checkers/* default.isValidLatitude */.Z.isValidLatitude(marker.lat) && Checkers/* default.isValidLongitude */.Z.isValidLongitude(marker.lng)) {
                    bounds.extend(new google.maps.LatLng(marker.lat, marker.lng));
                }
            });
            map.fitBounds(bounds);
        } else if (Checkers/* default.isValidLatitude */.Z.isValidLatitude(props.center.lat) && Checkers/* default.isValidLongitude */.Z.isValidLongitude(props.center.lng)) {
            map.setCenter(props.center);
        }
        map.setZoom(13);
        setMap(map);
    }, [
        props
    ]);
    var onUnmount = react.useCallback(function callback(map) {
        setMap(null);
    }, []);
    var isLoaded = (0,esm/* useLoadScript */.Db)({
        googleMapsApiKey: googleMapApiKey
    }).isLoaded;
    var ref3 = (0,react.useState)(false), initMapBounds = ref3[0], setInitMapBounds = ref3[1];
    (0,react.useEffect)(function() {
        if (propertiesMapPois != undefined && propertiesMapPois.length == 0) {
            return;
        }
        if (initMapBounds && searchWithMap) {
            return;
        }
        setIsMounted(true);
        if (map && !props.mouseMapClick && Checkers/* default.objChildExists */.Z.objChildExists(props, "propertiesPois")) {
            var bounds = new google.maps.LatLngBounds();
            propertiesMapPois.map(function(marker) {
                if (Checkers/* default.isValidLatitude */.Z.isValidLatitude(marker.lat) && Checkers/* default.isValidLongitude */.Z.isValidLongitude(marker.lng)) {
                    bounds.extend(new google.maps.LatLng(marker.lat, marker.lng));
                }
            });
            map.fitBounds(bounds);
        }
        setInitMapBounds(true);
    }, [
        isMounted,
        isLoaded,
        map,
        propertiesMapPois
    ]);
    var propertyMarkerClass = function() {
        var ref;
        var result = "d-flex justify-content-center align-items-center btn-map btn-design-color rounded-circle cursor-pointer";
        result += ((ref = props.app) === null || ref === void 0 ? void 0 : ref.designMode) ? "#ffffff" : "#000000";
        return result;
    };
    var openPropertyInfoWindow = function() {
        if (!map) {
            return;
        }
        var address = props.propertyAddress;
        var addressLine1 = address ? [
            address.address,
            address.city,
            address.zip
        ].filter(Checkers/* default.isValidString */.Z.isValidString).join(", ") : null;
        var addressLine2 = address ? address.country : null;
        var directionsHref = "https://www.google.com/maps/dir/?api=1&destination=" + props.center.lat + "," + props.center.lng;
        var images = Checkers/* default.isValidArray */.Z.isValidArray(props.propertyImages) ? props.propertyImages : [];
        var content = document.createElement("div");
        content.style.width = "260px";
        content.style.fontFamily = "inherit";
        content.style.borderRadius = "10px";
        content.style.overflow = "hidden";
        var carouselHtml = images.length > 0 ? '<div style="position:relative;height:220px;background:#eee;">' + '<img src="' + images[0] + '" style="width:100%;height:100%;object-fit:cover;display:block;" />' + "</div>" : "";
        content.innerHTML = '<div style="position:relative;">' + carouselHtml + '<button class="property-info-close" aria-label="Close" style="position:absolute;top:8px;right:8px;width:28px;height:28px;border:none;border-radius:50%;background:rgba(0,0,0,0.45);cursor:pointer;font-size:16px;line-height:1;color:#ffffff;padding:0;z-index:2;">&times;</button>' + "</div>" + '<div style="padding:14px 16px;">' + (Checkers/* default.isValidString */.Z.isValidString(props.propertyTitle) ? '<div style="font-size:15px;font-weight:600;color:#202124;margin-bottom:4px;">' + props.propertyTitle + "</div>" : "") + (Checkers/* default.isValidString */.Z.isValidString(addressLine1) || Checkers/* default.isValidString */.Z.isValidString(addressLine2) ? '<a rel="noreferrer" target="_blank" href="' + directionsHref + '" style="display:block;text-decoration:none;color:#5f6368;cursor:pointer;">' + (Checkers/* default.isValidString */.Z.isValidString(addressLine1) ? '<div style="font-size:13px;line-height:1.4;">' + addressLine1 + "</div>" : "") + (Checkers/* default.isValidString */.Z.isValidString(addressLine2) ? '<div style="font-size:13px;line-height:1.4;">' + addressLine2 + "</div>" : "") + "</a>" : "") + "</div>";
        var infoWindow = new google.maps.InfoWindow();
        content.querySelector(".property-info-close").addEventListener("click", function() {
            return infoWindow.close();
        });
        infoWindow.setContent(content);
        infoWindow.setPosition(props.center);
        infoWindow.open(map);
    };
    var applyMapFiltering = function(params) {
        if (!searchWithMap) {
            return;
        }
        // dispatch( setOffset( 0 ) )
        dispatch((0,actions/* fetchPropertiesAction */.SH)(params));
        fetchAllProperties(params);
    // dispatch( setApplyParams( 1 ) )
    // dispatch( setLoadingProperties( true ) );
    };
    // const mapBounds = map.getBounds()
    var mapHandler = function() {
        var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : propertiesParams;
        if (map != null && map.getBounds() != null && searchWithMap) {
            var latTop = map.getBounds().Ua.hi;
            var latBottom = map.getBounds().Ua.lo;
            var lngRight = map.getBounds().Ha.hi;
            var lngLeft = map.getBounds().Ha.lo;
            params.latTop = latTop;
            params.latBottom = latBottom;
            params.lngRight = lngRight;
            params.lngLeft = lngLeft;
            dispatch((0,actions/* updateMapBountries */.AX)(latTop, latBottom, lngLeft, lngRight));
            applyMapFiltering(params);
        }
    };
    var searchWithMapHandler = function() {
        dispatch((0,actions/* updateSearchWithMap */.FN)(!searchWithMap));
        applyMapFiltering(propertiesParams);
    };
    var mapRef = (0,react.useRef)();
    return isLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* GoogleMap */.b6, {
            ref: mapRef,
            onLoad: onLoad,
            onUnmount: onUnmount,
            clickableIcons: !forProperties,
            mapContainerStyle: {
                flexGrow: "1",
                height: "100%",
                background: "#f5f5f5"
            },
            onDragEnd: function() {
                return mapHandler();
            },
            onZoomChanged: mapHandler,
            options: {
                disableDefaultUI: disableUiControls ? true : false,
                zoomControl: disableUiControls ? false : true,
                scrollwheel: disableUiControls ? false : true,
                gestureHandling: disableUiControls ? "none" : null,
                styles: [
                    {
                        featureType: "poi",
                        stylers: [
                            {
                                visibility: "off"
                            }
                        ]
                    }
                ]
            },
            children: [
                !forProperties && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        !props.hidePin ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomMarker, {
                            map: map,
                            offsetY: 19,
                            offsetX: 19,
                            position: props.center,
                            marker_id: "property",
                            propertyMarkerClass: propertyMarkerClass(),
                            onClick: openPropertyInfoWindow
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                        props.randomizePin == 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Circle */.Cd, {
                                center: props.center,
                                radius: 500,
                                options: {
                                    strokeColor: "#ffffff",
                                    fillColor: "#ffffff",
                                    fillOpacity: 0.15
                                }
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                    ]
                }),
                props.enableMapClustering == "1" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* MarkerClusterer */.XL, {
                    gridSize: 50,
                    title: t("map.clickToZoom"),
                    maxZoom: 20,
                    minimumClusterSize: 2,
                    enableRetinaIcons: true,
                    children: function(clusterer) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: forProperties && propertiesMapPois.map(function(property, key) {
                                if (Checkers/* default.isValidLatitude */.Z.isValidLatitude(property.lat) && Checkers/* default.isValidLongitude */.Z.isValidLongitude(property.lng)) {
                                    var position = {
                                        lat: parseFloat(property.lat),
                                        lng: parseFloat(property.lng)
                                    };
                                    // console.log("clusterer", clusterer, clusterer.getClusters())
                                    var markerClass = props.center.lat == position.lat && props.center.lng == position.lng ? "d-flex justify-content-center align-items-center btn-map btn-design-color rounded-circle cursor-pointer " : "d-flex justify-content-center align-items-center btn-map bg-white rounded-circle cursor-pointer ";
                                    markerClass += props.designMode && props.center.lat == position.lat && props.center.lng == position.lng ? "text-white" : "text-black";
                                    if (Checkers/* default.isValidLatitude */.Z.isValidLatitude(position.lat) && Checkers/* default.isValidLongitude */.Z.isValidLongitude(position.lng)) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkerWrapper, {
                                            map: map,
                                            position: position,
                                            clusterer: clusterer,
                                            property: property,
                                            infoWindowState: props.infoWindowState,
                                            updateInfoWindowState: props.updateInfoWindowState,
                                            setInfoWindowState: props.setInfoWindowState,
                                            changeMarkerOnClick: props.changeMarkerOnClick,
                                            // changeMarkerIconOnHover={props.changeMarkerIconOnHover}
                                            openInfoWindow: props.openInfoWindow,
                                            markerClass: markerClass,
                                            pixelOffsetX: props.pixelOffsetX,
                                            pixelOffsetY: props.pixelOffsetY,
                                            secondState: props.secondState,
                                            randomizePin: props.randomizePin
                                        }, key);
                                    }
                                }
                            })
                        });
                    }
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: forProperties && propertiesMapPois.map(function(property, key) {
                        if (Checkers/* default.isValidLatitude */.Z.isValidLatitude(property.lat) && Checkers/* default.isValidLongitude */.Z.isValidLongitude(property.lng)) {
                            var position = {
                                lat: parseFloat(property.lat),
                                lng: parseFloat(property.lng)
                            };
                            if (Checkers/* default.isValidLatitude */.Z.isValidLatitude(position.lat) && Checkers/* default.isValidLongitude */.Z.isValidLongitude(position.lng)) {
                                var markerClass = props.center.lat == position.lat && props.center.lng == position.lng ? "d-flex justify-content-center align-items-center btn-map btn-design-color rounded-circle cursor-pointer " : "d-flex justify-content-center align-items-center btn-map bg-white rounded-circle cursor-pointer ";
                                markerClass += props.designMode && props.center.lat == position.lat && props.center.lng == position.lng ? "text-white" : "text-black";
                                // console.log("forDebug", "property", property)
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        props.randomizePin == 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Circle */.Cd, {
                                                center: position,
                                                radius: 220,
                                                options: {
                                                    strokeColor: "#ffffff",
                                                    fillColor: "#ffffff",
                                                    fillOpacity: 0.25
                                                }
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomMarker, {
                                            map: map,
                                            offsetY: 19,
                                            offsetX: 19,
                                            position: position,
                                            property: property,
                                            marker_id: "property_marker_" + property.property_id,
                                            propertyMarkerClass: markerClass,
                                            onClick: function() {
                                                props.updateInfoWindowState(property.property_id);
                                                props.changeMarkerOnClick(position.lat, position.lng, property.property_id);
                                            },
                                            disabled: props.infoWindowState === property.property_id,
                                            children: props.infoWindowState === property.property_id && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InfoWindow */.nx, {
                                                zIndex: 2,
                                                position: position,
                                                options: {
                                                    pixelOffset: new window.google.maps.Size(-props.pixelOffsetX, -props.pixelOffsetY)
                                                },
                                                onDomReady: function onDomReady() {
                                                    var noGalleryWidthDifference = 324 - this.content.children[0].clientWidth;
                                                    var noGalleryHeightDifference = 310 - this.content.children[0].clientHeight;
                                                    var width = (this.content.children[0].clientWidth + noGalleryWidthDifference) / 2;
                                                    var height = this.content.children[0].clientHeight + noGalleryHeightDifference + 20 + 76;
                                                    if (width > 0 && height > 20) {
                                                        props.openInfoWindow(width, height);
                                                    }
                                                    var gmEmptyElements = document.querySelectorAll(".gm-style-iw-tc");
                                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                                    try {
                                                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                        // @ts-ignore
                                                        for(var _iterator = gmEmptyElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                            var gmEmptyEl = _step.value;
                                                            gmEmptyEl.remove();
                                                        }
                                                    } catch (err) {
                                                        _didIteratorError = true;
                                                        _iteratorError = err;
                                                    } finally{
                                                        try {
                                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                                _iterator.return();
                                                            }
                                                        } finally{
                                                            if (_didIteratorError) {
                                                                throw _iteratorError;
                                                            }
                                                        }
                                                    }
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    id: "info_window_" + property.property_id,
                                                    className: "".concat(!props.secondState ? "bg-transparent border-radius-12 position-absolute mb-5 z-index-5" : "bg-white border-radius-12 position-absolute mb-5 z-index-5"),
                                                    style: {
                                                        overflow: "hidden",
                                                        boxShadow: !props.secondState ? "unset" : "0 6px 20px rgba(0,0,0,.2)"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                        href: window.location.origin + localizePath(property.sourcePath),
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        className: !props.secondState ? "invisible" : "InfoWindow-Properties__Thumb",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Gallery/* default */.Z, {
                                                                height: 210,
                                                                borderBottom: false,
                                                                property_id: property.property_id,
                                                                images: property.featured_images,
                                                                setInfoWindowState: props.setInfoWindowState,
                                                                captions: property.captions
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PanelBody/* default */.Z, {
                                                                property_id: property.property_id,
                                                                property_title: property.property_title,
                                                                property_moto: property.moto,
                                                                property_location: property.location,
                                                                minimumPrice: property.minimumPrice,
                                                                bedrooms: property.bedrooms,
                                                                capacity: property.capacity,
                                                                areaSqm: property.areaSqm,
                                                                bathrooms: property.bathrooms,
                                                                complexCount: property.complexCount,
                                                                estatePrice: property.estatePrice2,
                                                                isEstate: isEstate
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        }, key)
                                    ]
                                });
                            }
                        }
                    })
                })
            ]
        })
    });
}


/***/ })

}]);